export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-04-07 at 11.31.40 PM (1).bf79631c.jpeg";